import type { BaseOptions } from '../../common/types';
import type { DivisionSettingsVertex } from '../interfaces/vertices/division-settings';
import type { Types } from '../types';
import { getVertexId } from '../util';
import type { OutTypes } from './schedules';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';

export default (
  settings: Types.Mixed.Settings,
  options:  BaseOptions
): OutTypes.settings => {
  const edges: SerializedEdgesOnlyVertexExport<DivisionSettingsVertex> = {
    period:              settings.period              ? getVertexId(settings.period,              options) : undefined,
    defaultRootInterval: settings.defaultRootInterval ? getVertexId(settings.defaultRootInterval, options) : undefined,
  } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<DivisionSettingsVertex>>;
  const nonEdges = omitEdgesAndInternalProperties(settings, edges);

  return { ...nonEdges, ...edges };
};
